
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"23","viewBox":"0 0 23 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.166 9.797l-.603-.602a.426.426 0 00-.602.602l.602.602a2.985 2.985 0 010 4.216l-6.022 6.022a2.986 2.986 0 01-4.216 0l-.602-.602a2.985 2.985 0 010-4.216l6.022-6.022a.426.426 0 00-.602-.602l-6.022 6.022a3.837 3.837 0 000 5.42l.602.603a3.819 3.819 0 002.71 1.12 3.82 3.82 0 002.71-1.12l6.023-6.023a3.838 3.838 0 000-5.42z","fill":"#000"}}),_c('path',{attrs:{"d":"M21.879 1.723l-.602-.602a3.837 3.837 0 00-5.42 0L9.834 7.143a3.838 3.838 0 000 5.42l.603.603a.426.426 0 00.602-.603l-.602-.602a2.985 2.985 0 010-4.216l6.022-6.022a2.986 2.986 0 014.216 0l.602.602a2.985 2.985 0 010 4.216l-6.023 6.022a.426.426 0 10.603.603l6.022-6.023a3.837 3.837 0 000-5.42z","fill":"#000"}})])
          )
        }
      }
    